'use client';

import { c as _c } from "react/compiler-runtime";
import { Input } from '@/components/ui/input';
import { cn } from '@/utils/tailwindcss-override';
import { Search, X } from 'lucide-react';
import type React from 'react';
interface AccordionSearchBarProperties {
  query: string;
  onChange: (value: string) => void;
  placeholder: string;
  resultCount: number;
  totalCount: number;
  noResultsLabel: string;
  clearSearchLabel: string;
}
export const AccordionSearchBar: React.FC<AccordionSearchBarProperties> = t0 => {
  const $ = _c(27);
  const {
    query,
    onChange,
    placeholder,
    resultCount,
    totalCount,
    noResultsLabel,
    clearSearchLabel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Search className="pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-gray-400" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChange) {
    t2 = event => onChange(event.target.value);
    $[1] = onChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("font-body h-10 rounded-lg border-2 border-gray-200 bg-white pr-9 pl-9", "ring-0 ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0", "focus-visible:border-conveniat-green focus-visible:outline-hidden", "text-gray-900 placeholder:text-gray-400");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== placeholder || $[5] !== query || $[6] !== t2) {
    t4 = <Input type="text" value={query} onChange={t2} placeholder={placeholder} className={t3} />;
    $[4] = placeholder;
    $[5] = query;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== clearSearchLabel || $[9] !== onChange || $[10] !== query.length) {
    t5 = query.length > 0 && <button type="button" onClick={() => onChange("")} aria-label={clearSearchLabel} className="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer text-gray-400 transition-colors hover:text-gray-600"><X className="h-4 w-4" /></button>;
    $[8] = clearSearchLabel;
    $[9] = onChange;
    $[10] = query.length;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="relative">{t1}{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== noResultsLabel || $[16] !== query.length || $[17] !== resultCount) {
    t7 = query.length > 0 && resultCount === 0 && <p className="px-1 text-sm text-gray-500">{noResultsLabel}</p>;
    $[15] = noResultsLabel;
    $[16] = query.length;
    $[17] = resultCount;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== query.length || $[20] !== resultCount || $[21] !== totalCount) {
    t8 = query.length > 0 && resultCount > 0 && resultCount < totalCount && <p className="px-1 text-sm text-gray-400">{resultCount} / {totalCount}</p>;
    $[19] = query.length;
    $[20] = resultCount;
    $[21] = totalCount;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <div className="mb-4 space-y-2">{t6}{t7}{t8}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};